import { useContext, useMemo } from 'react';
import { GetUserModulesApiResponseDto, MessageDto, UserDto } from '../../general/dtos';
import { UserManagementDataContext } from '../../providers/user-management-provider';
import { UserAssignmentTable } from './user-assignment-table';

interface UserModuleAssignmentsProps {
    selectedUsers: UserDto[];
    saveUserModules: (sub: string, assigned: string[]) => Promise<GetUserModulesApiResponseDto | MessageDto | null>;
}

export function UserModuleAssignments({ selectedUsers, saveUserModules }: UserModuleAssignmentsProps) {
    const { allModules, allModulesLoading, userModules, userModulesLoading, userModulesError } = useContext(UserManagementDataContext)!;
    const user = selectedUsers.length === 1 ? selectedUsers[0] : null;
    const saved = user ? userModules[user.sub] : undefined;
    const assignments = useMemo(() => saved?.map(item => ({ key: item.module_key, assigned_at: item.assigned_at })), [saved]);
    const items = useMemo(() => allModules.map(item => ({ key: item.module_key, name: item.name, managed: item.is_managed })), [allModules]);
    if (!user) return <p>{selectedUsers.length ? 'Multiple users selected' : 'No user selected'}</p>;
    return <UserAssignmentTable key={user.sub} kind="module" items={items} assignments={assignments}
        loading={allModulesLoading || userModulesLoading} error={userModulesError}
        onSave={async keys => {
            const result = await saveUserModules(user.sub, keys);
            if (!result || !('data' in result)) throw new Error(result && 'message' in result ? result.message : 'Could not save assignments. Your selections are unchanged.');
            return result.data.map(item => ({ key: item.module_key, assigned_at: item.assigned_at }));
        }} />;
}
